export default "/static/build/maestro.png";